import { useEffect, useRef, useState } from 'react';

/**
 * Pictransは画像の読み込みに失敗した場合にも画像を返すことがあるため、独自のエラー判定処理を実施する
 */
export const usePictransErrorCheck = () => {
  const [isError, setIsError] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const imgElement = imgRef.current;
    if (!imgElement) {
      return;
    }

    const handler = () => {
      if (!imgElement.complete) {
        return;
      }

      // 一部の画像リクエストは404のときに1x1の画像を返すことがあるので、縦横ともに2px以上ない場合はエラーにする
      if (imgElement.naturalWidth < 2 && imgElement.naturalHeight < 2) {
        setIsError(true);
      }
    };

    handler(); // 初期状態でのチェック

    imgElement.addEventListener('load', handler);

    return () => imgElement.removeEventListener('load', handler);
  }, []);

  return { imgRef, isError };
};
